import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["operation", "trackingsection", "trackingtarget", "data"],
  _excluded2 = ["trackingsection"],
  _excluded3 = ["trackingsection"],
  _excluded4 = ["trackingsection"],
  _excluded5 = ["InternalRenderer", "tnode"],
  _excluded6 = ["InternalRenderer", "tnode"],
  _excluded7 = ["tnode", "style", "InternalRenderer"];
var _variableHandler;
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useEffect, useRef, useContext, useMemo, useState } from 'react';
import { Image, Linking, Pressable, View, useWindowDimensions, Platform, ScrollView } from 'react-native';
import RenderHtml, { defaultSystemFonts, Element, defaultHTMLElementModels, HTMLContentModel, HTMLElementModel, Text as TextElement } from 'react-native-render-html';
import { HTMLIframe, iframeModel, useHtmlIframeProps } from '@native-html/iframe-plugin';
import WebView from 'react-native-webview';
import { replaceElement, getAttributeValue, textContent, findAll, getChildren, prepend, prependChild, appendChild, prevElementSibling } from 'domutils';
/**
 * need import 'react-native-url-polyfill/auto' when use sanitize-html
 * otherwise it will not display iframe normally
 * because sanitize-html/index.js used `const parsed = new URL(value, base); `
 * it will report `URL.hostname is not implemented` under RN
 * and then delete iframe src attribute
 */

import 'react-native-url-polyfill/auto';
import sanitizeHtml from 'sanitize-html';
import { format } from 'date-fns';
import defaultOptions from '../../../constants/sanitizeHtmlOptions';
import {
// debounce,
transformToDateFnsFormat, decodeChatbotTextData, formatHtml } from '../../../utils/tools';
import { ConfigContext, dataMaintainer } from '../../ConfigProvider/rn/context';
// import { dataMaintainer } from '../../../components/ConfigProvider/rn/context';
import { Accordion } from '../../../components/Accordion/rn';
import { Text } from '../../../components/Text/rn'; // import { addObserver, removeObserver } from '../../../utils/intersectionObserver';

import { TRACKING_SECTION, TRACKING_TARGET, TRACKING_TYPE, TRACKING_OPERATION, ARTICLE_DETAIL_ANSWER_TYPE, ARTICLE_DETAIL_HYPERLINK_TYPE } from '../../../utils/tracking/constants'; // import { ScrollType, ElementScrollTrackManage } from '../../../utils/tracking/elementScrollTrack';

import { ButtonEvents, UIEvents } from '../../../types';
import { MsgType } from '../../Message/rn';
import ExpandIcon from '../../../assets/images/rn/Expand';
import { FONT_WEIGHT_MEDIUM } from '../../../styles/rn';
import ShopeeDefaultImage from '../../ShopeeDefaultImage/rn/index';
var REDIRECTION_BUTTON_TRIGGER_TYPE;
(function (REDIRECTION_BUTTON_TRIGGER_TYPE) {
  REDIRECTION_BUTTON_TRIGGER_TYPE["URL"] = "URL";
  REDIRECTION_BUTTON_TRIGGER_TYPE["TASK_BOT"] = "TASK_BOT";
  REDIRECTION_BUTTON_TRIGGER_TYPE["INTENT"] = "INTENT";
})(REDIRECTION_BUTTON_TRIGGER_TYPE || (REDIRECTION_BUTTON_TRIGGER_TYPE = {}));
var REGEXP_VARIABLE = /<a\s+href=\\?"variable:[^<]*>[^<]*<\/a>/g;
var REGEXP_DATE_FORMAT = /.*dateFormat=([^;\s"&;\?\\]*)/;
var DATE_VARIABLE_CONTAINER_CLASS = 'date-variable-container';
var STRING_VARIABLE_CONTAINER_CLASS = 'string-variable-container';
var HIDE_CLASS = 'hidden'; // const imgCssSelector = 'img:not(.ChatbotUI-accordion-item-icon)';

var DATE_FORMATS = ['yyyy-MM-dd HH:mm:ss', 'yyyy-MM-DD HH:mm:ss', 'yyyy-MM-dd HH:mm', 'yyyy-MM-DD HH:mm', 'yyyy-MM-dd', 'yyyy-MM-DD', 'dd/MM/yyyy', 'dd/MM/yy', 'DD/MM/yyyy', 'DD/MM/yy', 'yyyy/M/d', 'yyyy/M/d H:mm:ss', 'yyyy:M:d H:mm:ss', 'd/M/yyyy H:mm:ss', 'd:M:yyyy H:mm:ss', 'yyyy:M:d', 'd/M/yyyy', 'd:M:yyyy', 'dd-MM-yyyy', 'DD-MM-yyyy', 'dd-MM-yyyy HH:mm', 'DD-MM-yyyy HH:mm', 'DD MMM'];
var variableFormaterType;
(function (variableFormaterType) {
  variableFormaterType["Date"] = "date";
  variableFormaterType["String"] = "string";
})(variableFormaterType || (variableFormaterType = {}));
export var LINK_DATA_TYPE;
(function (LINK_DATA_TYPE) {
  LINK_DATA_TYPE["jumpNode"] = "jump-node";
  LINK_DATA_TYPE["jumpIntent"] = "jump-intent";
  LINK_DATA_TYPE["jumpOrderShortcut"] = "jump-order-shortcut";
})(LINK_DATA_TYPE || (LINK_DATA_TYPE = {}));
var variableHandler = (_variableHandler = {}, _defineProperty(_variableHandler, variableFormaterType.Date, function (content) {
  var _ref = content.match(REGEXP_DATE_FORMAT) || [],
    _ref2 = _slicedToArray(_ref, 2),
    dateFormat = _ref2[1];
  if (!dateFormat || !DATE_FORMATS.includes(decodeURIComponent(dateFormat.replaceAll('+', ' ')))) {
    return content;
  }
  var transformedDateFormat = transformToDateFnsFormat(decodeURIComponent(dateFormat.replaceAll('+', ' ')));
  var text = "".concat(content, "<span class=\"date-text ").concat(HIDE_CLASS, "\">").concat(format(new Date(), transformedDateFormat), "</span>");
  return "<span class=\"".concat(DATE_VARIABLE_CONTAINER_CLASS, "\">").concat(text, "</span>");
}), _defineProperty(_variableHandler, variableFormaterType.String, function (content, previewMockData) {
  var _previewMockData;
  previewMockData = (_previewMockData = previewMockData) !== null && _previewMockData !== void 0 ? _previewMockData : {};
  if (!previewMockData) {
    return content;
  }
  var variableList = content.match(/variable:([a-z|A-Z|\._]*)\?*/);
  if (!variableList || !(variableList !== null && variableList !== void 0 && variableList[1]) || !previewMockData[variableList === null || variableList === void 0 ? void 0 : variableList[1]]) {
    return content;
  }
  var text = "".concat(content, "<span class=\"date-text ").concat(HIDE_CLASS, "\">").concat(previewMockData[variableList === null || variableList === void 0 ? void 0 : variableList[1]], "</span>");
  return "<span class=\"".concat(STRING_VARIABLE_CONTAINER_CLASS, "\">").concat(text, "</span>");
}), _variableHandler);
/**
 * TODO:  DATE_VARIABLE_CONTAINER_CLASS、STRING_VARIABLE_CONTAINER_CLASS event binding
 */
// const getShowCustomVariable = (ele: Element) =>
//   debounce(() => {
//     ele.firstElementChild?.classList.add(HIDE_CLASS);
//     ele.lastElementChild?.classList.remove(HIDE_CLASS);
//   }, 50);
// const getHideCustomVariable = (ele: Element) =>
//   debounce(() => {
//     ele.firstElementChild?.classList.remove(HIDE_CLASS);
//     ele.lastElementChild?.classList.add(HIDE_CLASS);
//   }, 50);

var checkVariableTypeIsDate = function checkVariableTypeIsDate(html) {
  // 判断 variable type 是不是 date 类型
  var _ref3 = html.match(REGEXP_DATE_FORMAT) || [],
    _ref4 = _slicedToArray(_ref3, 2),
    dateFormat = _ref4[1];
  return !(!dateFormat || !DATE_FORMATS.includes(decodeURIComponent(dateFormat.replaceAll('+', ' '))));
};
function handleVariable(content, _ref5) {
  var shouldHandleDateVariable = _ref5.shouldHandleDateVariable,
    previewMockData = _ref5.previewMockData;
  if (!shouldHandleDateVariable) {
    return content;
  }
  var newText = content.replace(REGEXP_VARIABLE, function (matchText) {
    if (checkVariableTypeIsDate(matchText)) {
      return variableHandler[variableFormaterType.Date](matchText);
    } else {
      // 添加新的类型 字符串替换 目前 除了 date 其余都是这种类型
      return variableHandler[variableFormaterType.String](matchText, previewMockData);
    }
  });
  return newText;
}
var getJumpLinkData = function getJumpLinkData(url) {
  var _url$split;
  if (!url) {
    return {};
  }
  var customDataString = (url === null || url === void 0 ? void 0 : (_url$split = url.split('custom-data:')) === null || _url$split === void 0 ? void 0 : _url$split[1]) || '';
  var _decodeChatbotTextDat = decodeChatbotTextData(customDataString),
    dataType = _decodeChatbotTextDat['data-type'],
    jumpKey = _decodeChatbotTextDat['jump-key'];
  return {
    dataType: dataType,
    jumpKey: jumpKey
  };
};
var generateClickTrackingData = function generateClickTrackingData(trackingsection, trackingtarget, data) {
  return {
    trackingsection: trackingsection,
    trackingtarget: trackingtarget,
    data: data
  };
}; // const generateImpressionTrackingData = (
//   trackingsection: TRACKING_SECTION,
//   trackingtarget: TRACKING_TARGET,
//   data: ArticleContentTrackingDataProps | JumpLinkTrackingDataProps
// ) => ({
//   trackingsection,
//   trackingtarget,
//   trackingdata: JSON.stringify(data),
// });

var handleTrackerClick = function handleTrackerClick(_ref6) {
  var _dataMaintainer$track, _dataMaintainer$track2;
  var _ref6$operation = _ref6.operation,
    operation = _ref6$operation === void 0 ? TRACKING_OPERATION.CLICK : _ref6$operation,
    trackingsection = _ref6.trackingsection,
    trackingtarget = _ref6.trackingtarget,
    data = _ref6.data,
    rest = _objectWithoutProperties(_ref6, _excluded);
  (_dataMaintainer$track = dataMaintainer.tracker) === null || _dataMaintainer$track === void 0 ? void 0 : (_dataMaintainer$track2 = _dataMaintainer$track.dispatchTrack) === null || _dataMaintainer$track2 === void 0 ? void 0 : _dataMaintainer$track2.call(_dataMaintainer$track, _objectSpread({
    operation: operation,
    section: trackingsection,
    target: trackingtarget,
    data: data
  }, rest));
}; // const handleTrackImpression = (ele: HTMLElement, data: any) => {
//   const random = Math.random() + '';
//   ele.dataset.trackingkey = random;
//   dataMaintainer.addTrackerMap(random, data);
//   addObserver(ele);
// };
// const removeTrackImpression = (ele: HTMLElement) => {
//   const random = ele.dataset.trackingkey;
//   random && dataMaintainer.deleteTrackerMap(random);
//   removeObserver(ele);
// };

var getAppLink = function getAppLink(link) {
  // 是否返回的是 rn 或 native 链接
  var regx = /^in-app:(r?n)\/(\S+)$/;
  var splitInAppLink = regx.exec(link);
  return splitInAppLink;
};
var isInAppLink = function isInAppLink(link) {
  return getAppLink(link) != null;
};
var getHyperlinkType = function getHyperlinkType() {
  var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (isInAppLink(href)) {
    return ARTICLE_DETAIL_HYPERLINK_TYPE.IN_APP;
  } else if (isFormUrlLink(href)) {
    return ARTICLE_DETAIL_HYPERLINK_TYPE.FORM_URL;
  } else if (href.startsWith('https')) {
    return ARTICLE_DETAIL_HYPERLINK_TYPE.HTTPS;
  } else {
    return ARTICLE_DETAIL_HYPERLINK_TYPE.HTTP;
  }
};
export var isIntentLink = function isIntentLink(link) {
  return getIntentLink(link) != null;
};
export var getIntentLink = function getIntentLink() {
  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var regx = /^intent:/;
  var result = regx.exec(link);
  if (result === null) {
    return result;
  } else {
    return link.replace(regx, '');
  }
};
export var isFormUrlLink = function isFormUrlLink(link) {
  return getFormUrlLink(link) != null;
};
export var getFormUrlLink = function getFormUrlLink() {
  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var regx = /^form-url:/;
  var result = regx.exec(link);
  if (result === null) {
    return result;
  } else {
    return link.replace(regx, '');
  }
};
/**
 * @param { string } originClass 原始class
 * @param { string[] } targetClasses 待确认classes
 * @returns { boolean } targetClasses是否都在originClass中
 *
 * 判断targetClasses是否都在originClass中
 */

var isOriginClassHasTargetClasses = function isOriginClassHasTargetClasses() {
  var originClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var targetClasses = arguments.length > 1 ? arguments[1] : undefined;
  return targetClasses.every(function (className) {
    return originClass.search(className) > -1;
  });
};

/**
 * @param { Element } element 待处理的element
 * @param { string[] } classNames 后代classNames
 * @param { {style?: string, classStr?: string} } addedAttribs 需要添加的style/class
 * @param { {style?: string, classStr?: string} } options 附加选项
 *
 * 模拟css 后代选择器增加样式
 */
var ApplyStyleOrClassOnElementOffspring = function ApplyStyleOrClassOnElementOffspring(element, classNames, addedAttribs, options) {
  var _ref7 = options || {},
    includeElement = _ref7.includeElement;
  var haveClassesElements = findAll(function (currentElement) {
    var _currentElement$attri;
    var elementClass = (_currentElement$attri = currentElement.attribs) === null || _currentElement$attri === void 0 ? void 0 : _currentElement$attri.class;
    return isOriginClassHasTargetClasses(elementClass, classNames);
  }, [element]);
  var style = addedAttribs.style,
    classStr = addedAttribs.classStr;
  haveClassesElements.map(function (currentEle) {
    var _currentEle$attribs, _currentEle$attribs2;
    if (includeElement) {
      if (currentEle.name !== includeElement) {
        return;
      }
    }
    var newElement = new Element(currentEle.name, _objectSpread(_objectSpread({}, element.attribs || {}), {}, {
      style: "".concat(((_currentEle$attribs = currentEle.attribs) === null || _currentEle$attribs === void 0 ? void 0 : _currentEle$attribs.style) || '', " ").concat(style || ''),
      class: "".concat(((_currentEle$attribs2 = currentEle.attribs) === null || _currentEle$attribs2 === void 0 ? void 0 : _currentEle$attribs2.class) || '', " ").concat(classStr || '')
    }), currentEle.childNodes);
    replaceElement(currentEle, newElement);
  });
};
export var SHOULD_ADD_HIGH_LIGHT_TAG = ['u', 'a', 'abbr', 'strike', 'ins', 'li', 'ol'];
/**
 * TODO:
 * tracking
 * 1、changeTrackCloseArticleContentData
 * 2、articleContentTrackingData
 * 3、linkTrackingData
 */

export var SimpleRichText = function SimpleRichText(props) {
  var context = useContext(ConfigContext);
  var className = props.className,
    classNameStyles = props.classNameStyles,
    tagStyles = props.tagStyles,
    baseStyles = props.baseStyles,
    content = props.content,
    _props$options = props.options,
    options = _props$options === void 0 ? defaultOptions : _props$options,
    _props$shouldHandleDa = props.shouldHandleDateVariable,
    shouldHandleDateVariable = _props$shouldHandleDa === void 0 ? false : _props$shouldHandleDa,
    articleContentTrackingData = props.articleContentTrackingData,
    _props$disableSpecial = props.disableSpecialLink,
    disableSpecialLink = _props$disableSpecial === void 0 ? false : _props$disableSpecial,
    onClose = props.onClose,
    jumpNodeMap = props.jumpNodeMap,
    _props$jumpOrderShort = props.jumpOrderShortCutMap,
    jumpOrderShortCutMap = _props$jumpOrderShort === void 0 ? {} : _props$jumpOrderShort,
    _props$msgType = props.msgType,
    msgType = _props$msgType === void 0 ? MsgType.default : _props$msgType,
    _props$linkTrackingDa = props.linkTrackingData,
    linkTrackingData = _props$linkTrackingDa === void 0 ? {} : _props$linkTrackingDa,
    showExpandIcon = props.showExpandIcon,
    previewMockData = props.previewMockData,
    contentWidth = props.contentWidth,
    isUIOptimisationRecommender = props.isUIOptimisationRecommender;
  var processedContent = handleVariable(content, {
    shouldHandleDateVariable: shouldHandleDateVariable,
    previewMockData: previewMockData
  });
  var html = useMemo(function () {
    return formatHtml(sanitizeHtml(processedContent, options));
  }, [processedContent, options]);
  var ref = useRef(null);
  var _useWindowDimensions = useWindowDimensions(),
    screenWidth = _useWindowDimensions.width,
    screenHeight = _useWindowDimensions.height; // const variableMouseOverListners: Record<variableFormaterType, ((...args: any[]) => void)[]> = {
  //   [variableFormaterType.Date]: [],
  //   [variableFormaterType.String]: [],
  // };
  // const variableMouseOutListners: Record<variableFormaterType, ((...args: any[]) => void)[]> = {
  //   [variableFormaterType.Date]: [],
  //   [variableFormaterType.String]: [],
  // };

  /**
   * TODO: ElementScrollTrackManage
   */
  // const elementScrollTrackManage = new ElementScrollTrackManage();
  // const articleScrollsRef = useRef(0);
  // const tableScrollsRef = useRef(0);

  var counter = useRef({});
  var onClickEvent = function onClickEvent(e, href, htmlAttribs) {
    var _url$split2;

    // const url = e?.currentTarget?.href;
    var url = href;
    var whitelist = ['tel:', 'mailto:'];
    var isUrlStartsWithWhitelist = whitelist.some(function (item) {
      return url === null || url === void 0 ? void 0 : url.startsWith(item);
    });
    var customDataString = (url === null || url === void 0 ? void 0 : (_url$split2 = url.split('custom-data:')) === null || _url$split2 === void 0 ? void 0 : _url$split2[1]) || '';
    var _decodeChatbotTextDat2 = decodeChatbotTextData(customDataString),
      dataType = _decodeChatbotTextDat2['data-type'],
      jumpKey = _decodeChatbotTextDat2['jump-key'];
    trackClickLinkEvent(href);
    if (isUrlStartsWithWhitelist) {
      Linking.openURL(url);
      return;
    }
    if (e.preventDefault) {
      e.preventDefault();
    }
    if (dataType === LINK_DATA_TYPE.jumpNode) {
      var _context$eventEmitter, _context$eventEmitter2;
      if (disableSpecialLink) {
        return;
      }
      var jumpNodeParams = (jumpNodeMap === null || jumpNodeMap === void 0 ? void 0 : jumpNodeMap[jumpKey]) || {};
      context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, 'next', {
        // text: (e?.currentTarget as Element)?.textContent || '',
        text: hrefToTextContentMapping[href] || '',
        action: jumpNodeParams
      });
      return;
    }
    if (dataType === LINK_DATA_TYPE.jumpOrderShortcut) {
      var _context$eventEmitter3, _context$eventEmitter4;
      if (disableSpecialLink) {
        return;
      }
      context === null || context === void 0 ? void 0 : (_context$eventEmitter3 = context.eventEmitter) === null || _context$eventEmitter3 === void 0 ? void 0 : (_context$eventEmitter4 = _context$eventEmitter3.emit) === null || _context$eventEmitter4 === void 0 ? void 0 : _context$eventEmitter4.call(_context$eventEmitter3, 'next', {
        // text: (e?.currentTarget as Element)?.textContent || '',
        text: hrefToTextContentMapping[href] || '',
        action: jumpOrderShortCutMap
      });
      return;
    }
    if (dataType === LINK_DATA_TYPE.jumpIntent) {
      if (disableSpecialLink) {
        return;
      }
      try {
        var _context$eventEmitter5, _context$eventEmitter6;
        var params = JSON.parse(htmlAttribs['data-params'] || '');
        var jumpIntentParams = params || {};
        context === null || context === void 0 ? void 0 : (_context$eventEmitter5 = context.eventEmitter) === null || _context$eventEmitter5 === void 0 ? void 0 : (_context$eventEmitter6 = _context$eventEmitter5.emit) === null || _context$eventEmitter6 === void 0 ? void 0 : _context$eventEmitter6.call(_context$eventEmitter5, 'getIntent', {
          // text: (e?.currentTarget as Element)?.textContent || '',
          text: hrefToTextContentMapping[href] || '',
          action: jumpIntentParams
        });
      } catch (e) {
        console.log(e);
      }
      return;
    }
    if (url) {
      if (isIntentLink(url)) {
        var _context$eventEmitter7, _context$eventEmitter8;
        context === null || context === void 0 ? void 0 : (_context$eventEmitter7 = context.eventEmitter) === null || _context$eventEmitter7 === void 0 ? void 0 : (_context$eventEmitter8 = _context$eventEmitter7.emit) === null || _context$eventEmitter8 === void 0 ? void 0 : _context$eventEmitter8.call(_context$eventEmitter7, ButtonEvents.ClickArticleRedirectionButton, {
          // buttonName: (e as any)?.target?.innerText,
          buttonName: hrefToTextContentMapping[href],
          dialogueId: articleContentTrackingData === null || articleContentTrackingData === void 0 ? void 0 : articleContentTrackingData.chat_dialogue_id,
          intentId: getIntentLink(url),
          triggerType: REDIRECTION_BUTTON_TRIGGER_TYPE.INTENT
        });
        onClose === null || onClose === void 0 ? void 0 : onClose();
      } else if (isFormUrlLink(url)) {
        var _context$eventEmitter9, _context$eventEmitter10;
        context === null || context === void 0 ? void 0 : (_context$eventEmitter9 = context.eventEmitter) === null || _context$eventEmitter9 === void 0 ? void 0 : (_context$eventEmitter10 = _context$eventEmitter9.emit) === null || _context$eventEmitter10 === void 0 ? void 0 : _context$eventEmitter10.call(_context$eventEmitter9, ButtonEvents.Redirection, {
          text: '',
          action: {
            url_info: {
              url: getFormUrlLink(url)
            }
          }
        });
      } else {
        var _context$eventEmitter11, _context$eventEmitter12;
        context === null || context === void 0 ? void 0 : (_context$eventEmitter11 = context.eventEmitter) === null || _context$eventEmitter11 === void 0 ? void 0 : (_context$eventEmitter12 = _context$eventEmitter11.emit) === null || _context$eventEmitter12 === void 0 ? void 0 : _context$eventEmitter12.call(_context$eventEmitter11, ButtonEvents.Redirection, {
          text: '',
          action: {
            url_info: {
              url: url
            }
          }
        });
      }
    }
  };
  var onImageClickEvent = function onImageClickEvent(url) {
    if (articleContentTrackingData) {
      var trackingsection = articleContentTrackingData.trackingsection,
        restArticleContentTrackingData = _objectWithoutProperties(articleContentTrackingData, _excluded2);
      var data = generateClickTrackingData(trackingsection || TRACKING_SECTION[TRACKING_TYPE.ARTICLE_DETAIL], TRACKING_TARGET.imageOrGif, _objectSpread(_objectSpread({}, restArticleContentTrackingData), {}, {
        content: url || ''
      }));
      handleTrackerClick(data);
    }
    if (url) {
      var _context$eventEmitter13, _context$eventEmitter14;
      context === null || context === void 0 ? void 0 : (_context$eventEmitter13 = context.eventEmitter) === null || _context$eventEmitter13 === void 0 ? void 0 : (_context$eventEmitter14 = _context$eventEmitter13.emit) === null || _context$eventEmitter14 === void 0 ? void 0 : _context$eventEmitter14.call(_context$eventEmitter13, UIEvents.PreviewImage, {
        url: url
      });
    }
  }; // const updateArticleScrolls = () => {
  //   const articleScrolls = articleScrollsRef.current + 1;
  //   articleScrollsRef.current = articleScrolls;
  // changeTrackCloseArticleContentData?.({ articleScrolls });
  // };
  // const updateTableScrolls = () => {
  //   const tableScrolls = tableScrollsRef.current + 1;
  //   tableScrollsRef.current = tableScrolls;
  // changeTrackCloseArticleContentData?.({ tableScrolls });
  // };

  var onRedirectionButtonClick = function onRedirectionButtonClick(tnode) {
    var _tnode$attributes, _context$eventEmitter15, _context$eventEmitter16;
    var buttonJson = tnode === null || tnode === void 0 ? void 0 : (_tnode$attributes = tnode.attributes) === null || _tnode$attributes === void 0 ? void 0 : _tnode$attributes['data-button-json'];
    var buttonData;
    try {
      buttonData = JSON.parse(buttonJson || '');
    } catch (_unused) {}
    if (articleContentTrackingData) {
      var trackingsection = articleContentTrackingData.trackingsection,
        restArticleContentTrackingData = _objectWithoutProperties(articleContentTrackingData, _excluded3);
      var data = generateClickTrackingData(trackingsection || TRACKING_SECTION[TRACKING_TYPE.ARTICLE_DETAIL], TRACKING_TARGET.redirectionButton, _objectSpread(_objectSpread({}, restArticleContentTrackingData), {}, {
        content: buttonData.buttonName || ''
      }));
      handleTrackerClick(data);
    }
    buttonData && (context === null || context === void 0 ? void 0 : (_context$eventEmitter15 = context.eventEmitter) === null || _context$eventEmitter15 === void 0 ? void 0 : (_context$eventEmitter16 = _context$eventEmitter15.emit) === null || _context$eventEmitter16 === void 0 ? void 0 : _context$eventEmitter16.call(_context$eventEmitter15, ButtonEvents.ClickArticleRedirectionButton, _objectSpread(_objectSpread({}, buttonData), {}, {
      dialogueId: articleContentTrackingData === null || articleContentTrackingData === void 0 ? void 0 : articleContentTrackingData.chat_dialogue_id,
      disableClick: disableSpecialLink
    }))) && !disableSpecialLink && (buttonData.triggerType === REDIRECTION_BUTTON_TRIGGER_TYPE.TASK_BOT || buttonData.triggerType === REDIRECTION_BUTTON_TRIGGER_TYPE.INTENT) && (onClose === null || onClose === void 0 ? void 0 : onClose());
  };
  var handleAddEventListener = function handleAddEventListener() {
    var _ref$current, _ref$current$querySel;

    /**
     * TODO: Track
     */
    // ref?.current?.querySelectorAll('a')?.forEach((ele: HTMLAnchorElement) => {
    //   // trackLinkImpressionEvent(ele);
    // });
    // (ref?.current?.querySelectorAll(imgCssSelector) as NodeListOf<HTMLImageElement>)?.forEach(
    //   (ele: HTMLImageElement) => {

    /**
     * TODO: Track
     */
    // if (articleContentTrackingData) {
    //   const { trackingsection, ...restArticleContentTrackingData } = articleContentTrackingData;
    //   const impressionTrackingData = generateImpressionTrackingData(
    //     trackingsection || TRACKING_SECTION[TRACKING_TYPE.ARTICLE_DETAIL],
    //     TRACKING_TARGET.imageOrGif,
    //     {
    //       ...restArticleContentTrackingData,
    //       content: ele.src || '',
    //     },
    //   );
    //   handleTrackImpression(ele, impressionTrackingData);
    // }
    // },
    // );

    /**
     * TODO:  DATE_VARIABLE_CONTAINER_CLASS event binding
     */
    // ref?.current?.querySelectorAll(`.${DATE_VARIABLE_CONTAINER_CLASS}`)?.forEach((ele: Element, index) => {
    //   variableMouseOverListners[variableFormaterType.Date][index] = getShowCustomVariable(ele);
    //   variableMouseOutListners[variableFormaterType.Date][index] = getHideCustomVariable(ele);
    //   ele.firstElementChild?.addEventListener('mouseover', variableMouseOverListners[variableFormaterType.Date][index]);
    //   ele.lastElementChild?.addEventListener('mouseout', variableMouseOutListners[variableFormaterType.Date][index]);
    // });

    /**
     * TODO:  STRING_VARIABLE_CONTAINER_CLASS event binding
     */
    // ref?.current?.querySelectorAll(`.${STRING_VARIABLE_CONTAINER_CLASS}`)?.forEach((ele: Element, index) => {
    //   variableMouseOverListners[variableFormaterType.String][index] = getShowCustomVariable(ele);
    //   variableMouseOutListners[variableFormaterType.String][index] = getHideCustomVariable(ele);
    //   ele.firstElementChild?.addEventListener(
    //     'mouseover',
    //     variableMouseOverListners[variableFormaterType.String][index],
    //   );
    //   ele.lastElementChild?.addEventListener('mouseout', variableMouseOutListners[variableFormaterType.String][index]);
    // });
    // (ref?.current?.querySelectorAll('.redirection-button-to-taskbots-or-app-page') as NodeListOf<HTMLElement>)?.forEach(
    // (ele: HTMLElement) => {

    /**
     * TODO: Track
     */
    // if (articleContentTrackingData) {
    //   const { trackingsection, ...restArticleContentTrackingData } = articleContentTrackingData;
    //   const impressionTrackingData = generateImpressionTrackingData(
    //     trackingsection || TRACKING_SECTION[TRACKING_TYPE.ARTICLE_DETAIL],
    //     TRACKING_TARGET.redirectionButton,
    //     {
    //       ...restArticleContentTrackingData,
    //       content: ele.textContent || '',
    //     },
    //   );
    //   handleTrackImpression(ele, impressionTrackingData);
    // }
    //   },
    // );
    ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : (_ref$current$querySel = _ref$current.querySelectorAll('table')) === null || _ref$current$querySel === void 0 ? void 0 : _ref$current$querySel.forEach(function (ele) {
      var _ele$querySelectorAll;

      /**
       * TODO: Track
       */
      // if (articleContentTrackingData) {
      //   elementScrollTrackManage.addTrack(ele, ScrollType.Vertical, { scrollCallback: updateTableScrolls });
      // }

      /**
       * TODO: RN Element默认为flex，无需处理 display: inline-flex 样式
       */
      (_ele$querySelectorAll = ele.querySelectorAll('a')) === null || _ele$querySelectorAll === void 0 ? void 0 : _ele$querySelectorAll.forEach(function (hyperlink) {
        var parentElement = hyperlink.parentElement;
        var wrapper = document.createElement('div');
        wrapper.classList.add('table-hyperlink-wrapper');
        parentElement === null || parentElement === void 0 ? void 0 : parentElement.replaceChild(wrapper, hyperlink);
        wrapper.appendChild(hyperlink);
      });
      /**
       * TODO: 目前的RichText不处理此逻辑
       */

      var articleWidth = ref.current.clientWidth;
      var tableWidth = parseInt(ele.style.width);
      if (articleWidth < tableWidth) {
        var colGroup = ele.querySelectorAll('col');
        colGroup === null || colGroup === void 0 ? void 0 : colGroup.forEach(function (col) {
          var colWidth = +col.getAttribute('width');
          var newColWidth = Math.floor(colWidth * articleWidth / tableWidth);
          col.setAttribute('width', String(newColWidth));
        });
      }
    });
    /**
     * TODO: Track
     */
    // if (articleContentTrackingData) {
    //   elementScrollTrackManage.addTrack(ref.current!, ScrollType.Vertical, {
    //     containerElement: ref.current?.parentElement?.parentElement!,
    //     scrollCallback: updateArticleScrolls,
    //     trackScrollToEnd: true,
    //     scrollToEndCallBack: () => changeTrackCloseArticleContentData?.({ articleScrollToEnd: true }),
    //   });

    /**
     * TODO: Track
     */
    //   ref.current?.querySelectorAll('accordion-block')?.forEach((ele: Element) => {
    //     const trackingData = {
    //       trackingsection: TRACKING_SECTION[TRACKING_TYPE.ARTICLE_DETAIL],
    //       trackingtarget: TRACKING_TARGET.accordionCardTitle,
    //       trackingdataBasic: { ...articleContentTrackingData },
    //     };
    //     (ele as HTMLElement).setAttribute('tracking', JSON.stringify(trackingData));
    //   });
    // }
  };

  var handleRemoveEventListener = function handleRemoveEventListener() {
    /**
     * TODO: Track
     */
    // ref?.current?.querySelectorAll('a')?.forEach((ele: HTMLElement) => {
    //   articleContentTrackingData && removeTrackImpression(ele);
    // });
    // (ref?.current?.querySelectorAll(imgCssSelector) as NodeListOf<HTMLImageElement>)?.forEach((ele: HTMLElement) => {

    /**
     * TODO: Track
     */
    // articleContentTrackingData && removeTrackImpression(ele);
    // });

    /**
     * TODO: Track
     */
    // ref?.current?.querySelectorAll(`.${DATE_VARIABLE_CONTAINER_CLASS}`)?.forEach((ele: Element, index) => {
    //   ele.firstElementChild?.removeEventListener(
    //     'mouseover',
    //     variableMouseOverListners[variableFormaterType.Date][index],
    //   );
    //   ele.lastElementChild?.removeEventListener('mouseout', variableMouseOutListners[variableFormaterType.Date][index]);
    // });

    /**
     * TODO: Track
     */
    // ref?.current?.querySelectorAll(`.${STRING_VARIABLE_CONTAINER_CLASS}`)?.forEach((ele: Element, index) => {
    //   ele.firstElementChild?.removeEventListener(
    //     'mouseover',
    //     variableMouseOverListners[variableFormaterType.String][index],
    //   );
    //   ele.lastElementChild?.removeEventListener(
    //     'mouseout',
    //     variableMouseOutListners[variableFormaterType.String][index],
    //   );
    // });
    // (ref?.current?.querySelectorAll('.redirection-button-to-taskbots-or-app-page') as NodeListOf<HTMLElement>)?.forEach(
    // (ele: HTMLElement) => {
    // articleContentTrackingData && removeTrackImpression(ele);
    // }
    // );

    /**
     * TODO: Track
     */
    // articleContentTrackingData && elementScrollTrackManage.removeAllTrack();
  };
  var handleImageError = props.onImageError || function () {};
  var handleImageLoad = props.onImageLoad || function () {};
  var trackClickLinkEvent = function trackClickLinkEvent(href) {
    var content = hrefToTextContentMapping[href] || '';
    if (articleContentTrackingData) {
      var trackingsection = articleContentTrackingData.trackingsection,
        restArticleContentTrackingData = _objectWithoutProperties(articleContentTrackingData, _excluded4);
      var data = generateClickTrackingData(trackingsection || TRACKING_SECTION[TRACKING_TYPE.ARTICLE_DETAIL], TRACKING_TARGET.hyperlink, _objectSpread(_objectSpread({}, restArticleContentTrackingData), {}, {
        content: content,
        hyperlink_type: getHyperlinkType(href),
        answer_type: ARTICLE_DETAIL_ANSWER_TYPE.ARTICLE
      }));
      handleTrackerClick(data);
    }
    if (linkTrackingData.hyperlink) {
      var _data = generateClickTrackingData(TRACKING_SECTION[TRACKING_TYPE.ARTICLE_DETAIL], TRACKING_TARGET.hyperlink, _objectSpread(_objectSpread({}, linkTrackingData.hyperlink), {}, {
        content: content,
        hyperlink_type: getHyperlinkType(href),
        answer_type: ARTICLE_DETAIL_ANSWER_TYPE.RICH_TEXT
      }));
      handleTrackerClick(_data);
    } // @ts-ignore

    var _getJumpLinkData = getJumpLinkData(href),
      dataType = _getJumpLinkData.dataType;
    if (dataType === LINK_DATA_TYPE.jumpIntent && linkTrackingData !== null && linkTrackingData !== void 0 && linkTrackingData.jumpIntent) {
      var _data2 = generateClickTrackingData(TRACKING_SECTION[TRACKING_TYPE.JUMP_INTENT], TRACKING_TARGET.jumpIntent, _objectSpread(_objectSpread({}, linkTrackingData === null || linkTrackingData === void 0 ? void 0 : linkTrackingData.jumpIntent), {}, {
        is_change_order_option: msgType === MsgType.changeOrder ? 1 : 0
      }));
      handleTrackerClick(_data2);
    }
  }; // const trackLinkImpressionEvent = (ele: HTMLAnchorElement) => {
  //   if (articleContentTrackingData) {
  //     const { trackingsection, ...restArticleContentTrackingData } = articleContentTrackingData;
  //     const impressionTrackingData = generateImpressionTrackingData(
  //       trackingsection || TRACKING_SECTION[TRACKING_TYPE.ARTICLE_DETAIL],
  //       TRACKING_TARGET.hyperlink,
  //       {
  //         ...restArticleContentTrackingData,
  //         content: ele.textContent || '',
  //         hyperlink_type: getHyperlinkType(ele),
  //         answer_type: ARTICLE_DETAIL_ANSWER_TYPE.ARTICLE,
  //       },
  //     );
  //     handleTrackImpression(ele, impressionTrackingData);
  //   }
  //   if (linkTrackingData.hyperlink) {
  //     const impressionTrackingData = generateImpressionTrackingData(
  //       TRACKING_SECTION[TRACKING_TYPE.ARTICLE_DETAIL],
  //       TRACKING_TARGET.hyperlink,
  //       {
  //         ...linkTrackingData.hyperlink,
  //         content: ele.textContent || '',
  //         hyperlink_type: getHyperlinkType(ele),
  //         answer_type: ARTICLE_DETAIL_ANSWER_TYPE.RICH_TEXT,
  //       },
  //     );
  //     handleTrackImpression(ele, impressionTrackingData);
  //   }
  //   const url = ele?.href;
  //   const { dataType } = getJumpLinkData(url);
  //   if (dataType === LINK_DATA_TYPE.jumpIntent && linkTrackingData?.jumpIntent) {
  //     const data = generateImpressionTrackingData(
  //       TRACKING_SECTION[TRACKING_TYPE.JUMP_INTENT],
  //       TRACKING_TARGET.jumpIntent,
  //       { ...linkTrackingData?.jumpIntent, is_change_order_option: msgType === MsgType.changeOrder ? 1 : 0 },
  //     );
  //     handleTrackImpression(ele, data);
  //   }
  // };

  var imgSizeRef = useRef({});
  var hasParsedImages = useRef({});
  var timer = useRef(0);
  var richTextWidthRef = useRef(undefined);
  var imgLayoutSizeRef = useRef({});
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    imgSize = _useState2[0],
    setImgSize = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    imgLayoutSize = _useState4[0],
    setImgLayoutSize = _useState4[1];
  var ImageRenderer = function ImageRenderer(_ref8) {
    var _imgLayoutSize$src, _imgLayoutSize$src2, _imgSize$src, _imgSize$src2;
    var tnode = _ref8.tnode,
      style = _ref8.style;
    var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      imageIsError = _useState6[0],
      setImageIsError = _useState6[1]; // return <InternalRenderer tnode={tnode} {...props} /> fallback为默认渲染的element

    if (tnode.classes.includes('expend-icon')) {
      return /*#__PURE__*/React.createElement(ExpandIcon, {
        style: classesStyles['expend-icon']
      });
    }
    var src = tnode.attributes.src;
    var imgDisplayWidth = ((_imgLayoutSize$src = imgLayoutSize[src]) === null || _imgLayoutSize$src === void 0 ? void 0 : _imgLayoutSize$src.width) || richTextWidthRef.current || screenWidth;
    var imgDisplayHeight = ((_imgLayoutSize$src2 = imgLayoutSize[src]) === null || _imgLayoutSize$src2 === void 0 ? void 0 : _imgLayoutSize$src2.height) || screenHeight;
    if ((_imgSize$src = imgSize[src]) !== null && _imgSize$src !== void 0 && _imgSize$src.width && (_imgSize$src2 = imgSize[src]) !== null && _imgSize$src2 !== void 0 && _imgSize$src2.height) {
      var _imgSize$src3, _imgSize$src4;
      imgDisplayHeight = imgDisplayWidth / ((_imgSize$src3 = imgSize[src]) === null || _imgSize$src3 === void 0 ? void 0 : _imgSize$src3.width) * ((_imgSize$src4 = imgSize[src]) === null || _imgSize$src4 === void 0 ? void 0 : _imgSize$src4.height);
    }
    if (!showExpandIcon && (tnode.classes.some(function (item) {
      return item !== 'ChatbotUI-accordion-item-icon';
    }) || tnode.classes.length === 0)) {
      return /*#__PURE__*/React.createElement(Pressable, {
        onPress: function onPress() {
          onImageClickEvent(src);
        },
        style: {
          marginTop: 8,
          marginBottom: 8,
          borderRadius: 10,
          overflow: 'hidden'
        }
      }, imageIsError ? /*#__PURE__*/React.createElement(ShopeeDefaultImage, {
        style: {
          width: imgDisplayWidth,
          height: imgDisplayHeight
        }
      }) : /*#__PURE__*/React.createElement(Image, {
        source: {
          uri: src,
          width: imgDisplayWidth,
          height: imgDisplayHeight
        } // 为了解决 gif 不能动的问题 把 resizeMode="contain" 改为 resizeMode="stretch"
        ,

        resizeMode: "stretch",
        style: style,
        onLoad: function onLoad(e) {
          handleImageLoad(e);
        },
        onError: function onError(e) {
          handleImageError(e);
          setImageIsError(true);
        },
        onLayout: function onLayout(e) {
          var _e$nativeEvent$layout = e.nativeEvent.layout,
            width = _e$nativeEvent$layout.width,
            height = _e$nativeEvent$layout.height;
          imgLayoutSizeRef.current[src] = {
            width: width,
            height: height
          };
        }
      }));
    }
    return imageIsError ? /*#__PURE__*/React.createElement(ShopeeDefaultImage, {
      style: {
        width: imgDisplayWidth,
        height: imgDisplayHeight
      }
    }) : /*#__PURE__*/React.createElement(Image, {
      source: {
        uri: src,
        width: imgDisplayWidth,
        height: imgDisplayHeight
      } // 为了解决 gif 不能动的问题 把 resizeMode="contain" 改为 resizeMode="stretch"
      ,

      resizeMode: "stretch",
      style: style,
      onLoad: function onLoad(e) {
        handleImageLoad(e);
      },
      onError: function onError(e) {
        handleImageError(e);
        setImageIsError(true);
      },
      onLayout: function onLayout(e) {
        var _e$nativeEvent$layout2 = e.nativeEvent.layout,
          width = _e$nativeEvent$layout2.width,
          height = _e$nativeEvent$layout2.height;
        imgLayoutSizeRef.current[src] = {
          width: width,
          height: height
        };
      }
    });
  };
  var DivRenderer = function DivRenderer(_ref9) {
    var InternalRenderer = _ref9.InternalRenderer,
      tnode = _ref9.tnode,
      props = _objectWithoutProperties(_ref9, _excluded5);
    if (tnode.classes.includes('redirection-button-to-taskbots-or-app-page-container')) {
      var redirectionButtonToTaskbotsOrAppPageEle = (tnode.children || []).find(function (item) {
        return item.classes.some(function (className) {
          return className === 'redirection-button-to-taskbots-or-app-page';
        });
      });
      return /*#__PURE__*/React.createElement(Pressable, {
        onPress: function onPress() {
          onRedirectionButtonClick(redirectionButtonToTaskbotsOrAppPageEle);
        }
      }, /*#__PURE__*/React.createElement(InternalRenderer, _extends({
        tnode: tnode
      }, props)));
    }
    if (showExpandIcon && tnode.classes.some(function (item) {
      return item === 'expend-icon-container';
    })) {
      var imgElement = (tnode.children || []).find(function (item) {
        var _item$domNode;
        return ((_item$domNode = item.domNode) === null || _item$domNode === void 0 ? void 0 : _item$domNode.name) === 'img' && item.domNode.attribs.src;
      });
      var src = (imgElement === null || imgElement === void 0 ? void 0 : imgElement.attributes.src) || '';
      return /*#__PURE__*/React.createElement(Pressable, {
        onPress: function onPress() {
          onImageClickEvent(src);
        }
      }, /*#__PURE__*/React.createElement(InternalRenderer, _extends({
        tnode: tnode
      }, props)));
    }
    return /*#__PURE__*/React.createElement(InternalRenderer, _extends({
      tnode: tnode
    }, props));
  };
  var AccordionBlockRenderer = function AccordionBlockRenderer(_ref10) {
    var tnode = _ref10.tnode;
    var accordionList = tnode.attributes['data-json'] ? JSON.parse(decodeURIComponent(tnode.attributes['data-json'])) : [];
    return /*#__PURE__*/React.createElement(Accordion, {
      accordionList: accordionList
    });
  };
  var IframeRenderer = function IframeRenderer(props) {
    var iframeProps = useHtmlIframeProps(props); // Do customize the props here; wrap with your own container...

    return /*#__PURE__*/React.createElement(HTMLIframe, iframeProps);
  };
  var TableRenderer = function TableRenderer(_ref11) {
    var InternalRenderer = _ref11.InternalRenderer,
      tnode = _ref11.tnode,
      props = _objectWithoutProperties(_ref11, _excluded6);
    return /*#__PURE__*/React.createElement(ScrollView, {
      horizontal: true
    }, /*#__PURE__*/React.createElement(InternalRenderer, _extends({
      tnode: tnode
    }, props)));
  };
  var ColgroupRenderer = function ColgroupRenderer() {
    return null;
  };
  var ItalicRenderer = function ItalicRenderer(_ref12) {
    var _tnode$domNode, _tnode$domNode$childr;
    var tnode = _ref12.tnode,
      style = _ref12.style,
      InternalRenderer = _ref12.InternalRenderer,
      props = _objectWithoutProperties(_ref12, _excluded7);
    var textContent = ((_tnode$domNode = tnode.domNode) === null || _tnode$domNode === void 0 ? void 0 : (_tnode$domNode$childr = _tnode$domNode.children) === null || _tnode$domNode$childr === void 0 ? void 0 : _tnode$domNode$childr[0]).data;
    if (Platform.OS === 'ios') {
      return /*#__PURE__*/React.createElement(Text, {
        styles: _objectSpread(_objectSpread({}, style), {}, {
          transform: [{
            skewX: '-15deg'
          }],
          lineHeight: 24,
          fontStyle: 'normal'
        }),
        content: textContent
      });
    } else {
      return /*#__PURE__*/React.createElement(InternalRenderer, _extends({
        style: style,
        tnode: tnode
      }, props));
    }
  };
  var renderers = {
    img: ImageRenderer,
    div: DivRenderer,
    'accordion-block': AccordionBlockRenderer,
    iframe: IframeRenderer,
    table: TableRenderer,
    colgroup: ColgroupRenderer,
    em: ItalicRenderer,
    i: ItalicRenderer
  };
  var renderersProps = {
    a: {
      onPress: function onPress(event, href, htmlAttribs) {
        onClickEvent(event, href, htmlAttribs);
      }
    },
    iframe: {
      scalesPageToFit: true
    }
  };
  var AccordionBlock = HTMLElementModel.fromCustomModel({
    tagName: 'accordion-block',
    contentModel: HTMLContentModel.block
  });
  var customHTMLElementModels = {
    span: defaultHTMLElementModels.span.extend({
      contentModel: HTMLContentModel.mixed
    }),
    'accordion-block': AccordionBlock,
    iframe: iframeModel,
    colgroup: defaultHTMLElementModels.div
  };
  var hrefToTextContentMapping = {};
  var onElement = function onElement(element) {
    var _element$attribs, _element$attribs2, _element$attribs6, _element$attribs7, _element$attribs8, _element$attribs10, _element$attribs11, _element$attribs12, _element$attribs13, _element$attribs14, _element$attribs16;

    // 按节点顺序，深度优先遍历所有element
    switch (element.tagName) {
      case 'img':
        var newElement = element;
        var src = element.attribs.src.replace('file-proxy.seller.shopee.com', 'fileproxy.scsusercontent.com');
        if (element.attribs.src.search('file-proxy.seller.shopee.com') >= 0) {
          var newImg = new Element(element.name, _objectSpread(_objectSpread({}, element.attribs), {}, {
            src: src
          }), element.childNodes);
          replaceElement(element, newImg);
          newElement = newImg;
        }
        if (showExpandIcon) {
          if (getAttributeValue(newElement, 'class') === 'ChatbotUI-accordion-item-icon') {
            break;
          }
          var expendIcon = new Element('img', {
            class: 'expend-icon',
            'preview-src': getAttributeValue(newElement, 'src') || ''
          });
          var imgContainer = new Element('div', {
            class: 'expend-icon-container'
          }, [newElement.cloneNode(), expendIcon]);
          replaceElement(newElement, imgContainer);
        }
        if (!hasParsedImages.current[src] && src) {
          hasParsedImages.current[src] = 1;
          Image.getSize(src, function (width, height) {
            imgSizeRef.current[src] = {
              width: width,
              height: height
            };
          }, function () {
            imgSizeRef.current[src] = {
              width: 0,
              height: 0
            };
          });
        }
        break;
      case 'a':
        var url = (_element$attribs = element.attribs) === null || _element$attribs === void 0 ? void 0 : _element$attribs.href;
        var elementClass = (_element$attribs2 = element.attribs) === null || _element$attribs2 === void 0 ? void 0 : _element$attribs2.class; // &.chatbot-text-change-order-link {
        //   color: #4080ee;
        //   &.disabled {
        //     color: rgba(0, 0, 0, 0.54);
        //   }
        // }

        var isChangeOrder = isOriginClassHasTargetClasses(elementClass, ['chatbot-text-change-order-link']);
        hrefToTextContentMapping[url || 'href'] = textContent(element);
        if (disableSpecialLink) {
          var _url$split3;
          var customDataString = (url === null || url === void 0 ? void 0 : (_url$split3 = url.split('custom-data:')) === null || _url$split3 === void 0 ? void 0 : _url$split3[1]) || '';
          var _decodeChatbotTextDat3 = decodeChatbotTextData(customDataString),
            dataType = _decodeChatbotTextDat3['data-type'];
          if (dataType === LINK_DATA_TYPE.jumpNode || dataType === LINK_DATA_TYPE.jumpIntent || dataType === LINK_DATA_TYPE.jumpOrderShortcut) {
            var addClassElement = new Element('a', _objectSpread(_objectSpread({}, element.attribs), {}, {
              class: "".concat(elementClass || '', " ").concat(isChangeOrder ? 'diabled-change-order' : 'disabled')
            }), element.childNodes);
            replaceElement(element, addClassElement);
          }
        } else {
          var _element$attribs3;
          var newAElement = new Element(element.name, _objectSpread(_objectSpread({}, element.attribs), {}, {
            style: "".concat(((_element$attribs3 = element.attribs) === null || _element$attribs3 === void 0 ? void 0 : _element$attribs3.style) || '', "color: #4080ee;font-size: ").concat(isChangeOrder ? '12px' : '16px', ";text-decoration: none")
          }), element.childNodes);
          replaceElement(element, newAElement);
        }
        break;
      case 'u':
        var UAElements = findAll(function (currentElement) {
          return currentElement.name === 'a';
        }, [element]);
        if ((UAElements === null || UAElements === void 0 ? void 0 : UAElements.length) > 0) {
          var _element$attribs4;
          var _newElement = new Element('u',
          // 为了去除a标签下划线,先去掉u标签的下划线
          _objectSpread(_objectSpread({}, element.attribs), {}, {
            class: "".concat(((_element$attribs4 = element.attribs) === null || _element$attribs4 === void 0 ? void 0 : _element$attribs4.class) || '', " underline-a")
          }), element.childNodes); // 然后给其他子元素增加下划线

          var otherChildren = getChildren(_newElement);
          _toConsumableArray(otherChildren).forEach(function (childEle) {
            // 如果是标签,直接加上下划线
            if (childEle.name && childEle.name !== 'a') {
              var _childEle$attribs;
              var newTrChildEle = new Element(childEle.name, _objectSpread(_objectSpread({}, childEle.attribs), {}, {
                style: "".concat(((_childEle$attribs = childEle.attribs) === null || _childEle$attribs === void 0 ? void 0 : _childEle$attribs.style) || '', "text-decoration: underline")
              }), childEle.childNodes);
              replaceElement(childEle, newTrChildEle);
            } else if (childEle.data) {
              // 如果是纯文本,添加到span标签内
              var _content = new TextElement("".concat(childEle.data));
              var _newTrChildEle = new Element('span', {
                style: 'text-decoration: underline'
              }, [_content]);
              replaceElement(childEle, _newTrChildEle);
            }
          });
          replaceElement(element, _newElement);
        }
        break;
      case 'li':
        var indentClass = ['ql-indent-1', 'ql-indent-2', 'ql-indent-3', 'ql-indent-4'].find(function (className) {
          var _element$attribs5;
          return (((_element$attribs5 = element.attribs) === null || _element$attribs5 === void 0 ? void 0 : _element$attribs5.class) || '').search(className) > -1;
        }); // li.ql-indent-1 {
        //   padding-left: 4.5em;
        // }
        // li.ql-indent-2 {
        //   padding-left: 7.5em;
        // }
        // li.ql-indent-3 {
        //   padding-left: 10.5em;
        // }
        // li.ql-indent-4 {
        //   padding-left: 13.5em;
        // }

        var addedClass = '';
        if (indentClass) {
          addedClass = "li-".concat(indentClass);
        } // li[data-list='bullet'] > .ql-ui:before {
        //   content: '\2022';
        // }

        if (((_element$attribs6 = element.attribs) === null || _element$attribs6 === void 0 ? void 0 : _element$attribs6['data-list']) === 'bullet') {
          var _children = getChildren(element);
          _toConsumableArray(_children).map(function (childEle) {
            var _childEle$attribs2;
            if (isOriginClassHasTargetClasses((_childEle$attribs2 = childEle.attribs) === null || _childEle$attribs2 === void 0 ? void 0 : _childEle$attribs2.class, ['ql-ui'])) {
              var _content2 = new TextElement('•');
              var newSpanEle = new Element('div', {
                'list-type': 'list-type'
              }, [_content2]);
              prepend(childEle, newSpanEle);
            }
          });
        } // li[data-list='ordered'] {
        //   counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
        //   counter-increment: list-0;
        // }
        // li[data-list='ordered'] > .ql-ui:before {
        //   content: counter(list-0, decimal) '. ';
        // }
        // li[data-list='ordered'].ql-indent-1 {
        //   counter-increment: list-1;
        // }
        // li[data-list='ordered'].ql-indent-1 > .ql-ui:before {
        //   content: counter(list-1, lower-alpha) '. ';
        // }
        // li[data-list='ordered'].ql-indent-1 {
        //   counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
        // }
        // li[data-list='ordered'].ql-indent-2 {
        //   counter-increment: list-2;
        // }
        // li[data-list='ordered'].ql-indent-2 > .ql-ui:before {
        //   content: counter(list-2, lower-roman) '. ';
        // }
        // li[data-list='ordered'].ql-indent-2 {
        //   counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
        // }
        // li[data-list='ordered'].ql-indent-3 {
        //   counter-increment: list-3;
        // }
        // li[data-list='ordered'].ql-indent-3 > .ql-ui:before {
        //   content: counter(list-3, decimal) '. ';
        // }
        // li[data-list='ordered'].ql-indent-3 {
        //   counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
        // }
        // li[data-list='ordered'].ql-indent-4 {
        //   counter-increment: list-4;
        // }
        // li[data-list='ordered'].ql-indent-4 > .ql-ui:before {
        //   content: counter(list-4, lower-alpha) '. ';
        // }
        // li[data-list='ordered'].ql-indent-4 {
        //   counter-reset: list-5 list-6 list-7 list-8 list-9;
        // }

        if (((_element$attribs7 = element.attribs) === null || _element$attribs7 === void 0 ? void 0 : _element$attribs7['data-list']) === 'ordered') {
          var _children2 = getChildren(element);
          _toConsumableArray(_children2).map(function (childEle) {
            var _childEle$attribs3;
            if (isOriginClassHasTargetClasses((_childEle$attribs3 = childEle.attribs) === null || _childEle$attribs3 === void 0 ? void 0 : _childEle$attribs3.class, ['ql-ui'])) {
              // const isCounterOriginal = false;
              switch (indentClass) {
                case 'ql-indent-1':
                  counter.current['ql-indent-2'] = undefined; // counter-reset

                  counter.current['ql-indent-3'] = undefined;
                  counter.current['ql-indent-4'] = undefined;
                  if (counter.current[indentClass] === undefined) {
                    counter.current[indentClass] = "a";
                  } else {
                    var _codePointAt, _ref13;
                    counter.current[indentClass] = String.fromCharCode((((_codePointAt = (_ref13 = counter.current[indentClass]).codePointAt) === null || _codePointAt === void 0 ? void 0 : _codePointAt.call(_ref13, 0)) || 0) + 1);
                  }
                  break;
                case 'ql-indent-4':
                  if (counter.current[indentClass] === undefined) {
                    counter.current[indentClass] = "a";
                  } else {
                    var _codePointAt2, _ref14;
                    counter.current[indentClass] = String.fromCharCode((((_codePointAt2 = (_ref14 = counter.current[indentClass]).codePointAt) === null || _codePointAt2 === void 0 ? void 0 : _codePointAt2.call(_ref14, 0)) || 0) + 1);
                  }
                  break;
                case 'ql-indent-2':
                  counter.current['ql-indent-3'] = undefined;
                  counter.current['ql-indent-4'] = undefined;
                  if (counter.current[indentClass] === undefined) {
                    counter.current[indentClass] = "\u2170";
                  } else {
                    var _codePointAt3, _ref15;
                    counter.current[indentClass] = String.fromCharCode((((_codePointAt3 = (_ref15 = counter.current[indentClass]).codePointAt) === null || _codePointAt3 === void 0 ? void 0 : _codePointAt3.call(_ref15, 0)) || 0) + 1);
                  }
                  break;
                case 'ql-indent-3':
                  counter.current['ql-indent-4'] = undefined;
                  counter.current[indentClass] = (counter.current[indentClass] || 0) + 1;
                  break;
                default:
                  var counterDefault = counter.current.default;
                  counter.current = {};
                  counter.current.default = (counterDefault || 0) + 1;
                  break;
              }
              var _content3 = new TextElement("".concat(counter.current[indentClass || 'default'], ". "));
              var newSpanEle = new Element('div', {
                'list-type': 'list-type'
              }, [_content3]);
              prepend(childEle, newSpanEle);
            }
          });
        } // li > .ql-ui:before {
        //   display: inline-block;
        //   margin-left: -1.5em;
        //   margin-right: 0.3em;
        //   text-align: right;
        //   white-space: nowrap;
        //   width: 1.2em;
        // }

        var children = getChildren(element);
        children.map(function (childEle) {
          var _childEle$attribs4;
          if (isOriginClassHasTargetClasses((_childEle$attribs4 = childEle.attribs) === null || _childEle$attribs4 === void 0 ? void 0 : _childEle$attribs4.class, ['ql-ui'])) {
            var _beforeEle$attribs;
            var beforeEle = prevElementSibling(childEle);
            if (beforeEle !== null && beforeEle !== void 0 && (_beforeEle$attribs = beforeEle.attribs) !== null && _beforeEle$attribs !== void 0 && _beforeEle$attribs['list-type']) {
              var _beforeEle$attribs2;
              var _newElement2 = new Element(beforeEle.name, _objectSpread(_objectSpread({}, beforeEle.attribs), {}, {
                class: "".concat(((_beforeEle$attribs2 = beforeEle.attribs) === null || _beforeEle$attribs2 === void 0 ? void 0 : _beforeEle$attribs2.class) || '', " ql-ui-before")
              }), beforeEle.childNodes);
              replaceElement(beforeEle, _newElement2);
              addedClass = "".concat(addedClass, " li-ql-ui-before");
            }
          }
        });
        var newLiEle = new Element(element.name, _objectSpread(_objectSpread({}, element.attribs), {}, {
          class: "".concat(((_element$attribs8 = element.attribs) === null || _element$attribs8 === void 0 ? void 0 : _element$attribs8.class) || '', " ").concat(addedClass)
        }), element.childNodes);
        replaceElement(element, newLiEle);
        break;
      case 'ul':
      case 'ol':
        counter.current = {};
        break;
      case 'table':
        // table a {
        //   overflow: hidden;
        //   white-space: nowrap;
        //   text-overflow: ellipsis;
        //   display: inline-block;
        //   max-width: 100%;
        // }
        var AElements = findAll(function (currentElement) {
          return currentElement.name === 'a';
        }, [element]);
        AElements.map(function (aEle) {
          var _aEle$attribs;
          var newElement = new Element(aEle.name, _objectSpread(_objectSpread({}, aEle.attribs), {}, {
            class: "".concat(((_aEle$attribs = aEle.attribs) === null || _aEle$attribs === void 0 ? void 0 : _aEle$attribs.class) || '', " table-a")
          }), aEle.childNodes);
          replaceElement(aEle, newElement);
        });
        var colGroupEle = element.children.find(function (node) {
          return node.name === 'colgroup';
        });
        if (!colGroupEle) {
          break;
        }
        var realTableWith = 0;
        var colWidthArr = colGroupEle.children.map(function (col) {
          var colWidth = Number(col.attribs.width || 0);
          if (colWidth > 0) {
            realTableWith = realTableWith + colWidth;
          }
          return Number(col.attribs.width || 0);
        });
        if (realTableWith > 0) {
          var _element$attribs9;
          var newTableStyle = (((_element$attribs9 = element.attribs) === null || _element$attribs9 === void 0 ? void 0 : _element$attribs9.style) || '').replace(/width:\s*\d+(\w*)/, "width: ".concat(realTableWith, "$1"));
          var newTableEle = new Element(element.name, _objectSpread(_objectSpread({}, element.attribs), {}, {
            style: "".concat(newTableStyle)
          }), element.childNodes);
          replaceElement(element, newTableEle);
        }
        var TrElements = findAll(function (currentElement) {
          return currentElement.name === 'tr';
        }, [element]);
        TrElements.map(function (trEle) {
          trEle.children.map(function (trChild, childIndex) {
            var _trChild$attribs;
            var newTrChildEle = new Element(trChild.name, _objectSpread(_objectSpread({}, trChild.attribs), {}, {
              style: "max-width:".concat(colWidthArr[childIndex] ? colWidthArr[childIndex] + 'px;' : 'auto').concat(((_trChild$attribs = trChild.attribs) === null || _trChild$attribs === void 0 ? void 0 : _trChild$attribs.style) || '')
            }), trChild.childNodes);
            replaceElement(trChild, newTrChildEle);
          });
        });
        break;
      default:
        break;
    } // if (element.attribs.class && element.attribs.class.search(DATE_VARIABLE_CONTAINER_CLASS) > -1) {
    // }
    // if (element.attribs.class && element.attribs.class.search(STRING_VARIABLE_CONTAINER_CLASS) > -1) {
    // }

    if (isOriginClassHasTargetClasses((_element$attribs10 = element.attribs) === null || _element$attribs10 === void 0 ? void 0 : _element$attribs10.class, ['redirection-button-to-taskbots-or-app-page'])) {
      var container = new Element('div', {
        class: 'redirection-button-to-taskbots-or-app-page-container'
      }, [element]);
      replaceElement(element, container);
    } // .ql-code-block-container {
    //   .ql-ui {
    //     right: 5px;
    //     top: 5px;
    //   }
    // }

    if (isOriginClassHasTargetClasses((_element$attribs11 = element.attribs) === null || _element$attribs11 === void 0 ? void 0 : _element$attribs11.class, ['ql-code-block-container'])) {
      ApplyStyleOrClassOnElementOffspring(element, ['ql-ui'], {
        classStr: 'ql-code-block-container-ql-ui'
      });
    } // .ql-container .qlbt-selection-line {
    //   &.qlbt-selection-line-left {
    //     &::before {
    //       position: absolute;
    //       left: -2px;
    //       top: -2px;
    //       content: '';
    //       width: 5px;
    //       height: 5px;
    //       background-color: #0589f3;
    //       border-radius: 5px;
    //     }
    //   }
    // &.qlbt-selection-line-right {
    //   &::before {
    //     position: absolute;
    //     right: -2px;
    //     bottom: -3px;
    //     content: '';
    //     width: 5px;
    //     height: 5px;
    //     background-color: #0589f3;
    //     border-radius: 5px;
    //   }
    // }

    if (isOriginClassHasTargetClasses((_element$attribs12 = element.attribs) === null || _element$attribs12 === void 0 ? void 0 : _element$attribs12.class, ['ql-container'])) {
      var haveLeftClassesElements = findAll(function (currentElement) {
        var _currentElement$attri2;
        var elementClass = (_currentElement$attri2 = currentElement.attribs) === null || _currentElement$attri2 === void 0 ? void 0 : _currentElement$attri2.class;
        return isOriginClassHasTargetClasses(elementClass, ['qlbt-selection-line', 'qlbt-selection-line-left']);
      }, [element]);
      haveLeftClassesElements.map(function (currentEle) {
        var newSpanEle = new Element('div', {
          class: 'qlbt-selection-line-left-before'
        });
        prependChild(currentEle, newSpanEle);
      });
      var haveRightClassesElements = findAll(function (currentElement) {
        var _currentElement$attri3;
        var elementClass = (_currentElement$attri3 = currentElement.attribs) === null || _currentElement$attri3 === void 0 ? void 0 : _currentElement$attri3.class;
        return isOriginClassHasTargetClasses(elementClass, ['qlbt-selection-line', 'qlbt-selection-line-right']);
      }, [element]);
      haveRightClassesElements.map(function (currentEle) {
        var newSpanEle = new Element('div', {
          class: 'qlbt-selection-line-right-before'
        });
        appendChild(currentEle, newSpanEle);
      });
    }
    /**
     * TODO: hover style
     */
    // .qlbt-operation-menu-item {
    //   &:hover {
    //     background-color: #efefef;
    //   }

    if (isOriginClassHasTargetClasses((_element$attribs13 = element.attribs) === null || _element$attribs13 === void 0 ? void 0 : _element$attribs13.class, ['qlbt-operation-menu-item'])) {} // .qlbt-col-tool-cell {
    //   &:first-child {
    //     border-left: 1px solid #000;
    //   }
    // }

    if (isOriginClassHasTargetClasses((_element$attribs14 = element.attribs) === null || _element$attribs14 === void 0 ? void 0 : _element$attribs14.class, ['qlbt-col-tool-cell'])) {
      var beforeEle = prevElementSibling(element);
      if (!beforeEle) {
        var _element$attribs15;
        var _newElement3 = new Element(element.name, _objectSpread(_objectSpread({}, element.attribs), {}, {
          class: "".concat(((_element$attribs15 = element.attribs) === null || _element$attribs15 === void 0 ? void 0 : _element$attribs15.class) || '', " qlbt-col-tool-cell-first-child")
        }), element.childNodes);
        replaceElement(element, _newElement3);
      }
    }
    /**
     * TODO: hover style
     */
    // .qlbt-col-tool-cell-holder {
    //   &:hover {
    //     background-color: #0589f3;
    //   }

    if (isOriginClassHasTargetClasses((_element$attribs16 = element.attribs) === null || _element$attribs16 === void 0 ? void 0 : _element$attribs16.class, ['qlbt-col-tool-cell-holder'])) {
      var leftElement = new Element('div', {
        class: 'qlbt-col-tool-cell-holder-faker'
      });
      var rightElement = new Element('div', {
        class: 'qlbt-col-tool-cell-holder-faker'
      });
      prependChild(element, leftElement);
      appendChild(element, rightElement);
    }
    SHOULD_ADD_HIGH_LIGHT_TAG.map(function (tag) {
      if (element.tagName !== tag) {
        return;
      }
      var highlightElements = findAll(function (currentElement) {
        var _currentElement$attri4;
        var elementClass = (_currentElement$attri4 = currentElement.attribs) === null || _currentElement$attri4 === void 0 ? void 0 : _currentElement$attri4.class;
        return isOriginClassHasTargetClasses(elementClass, ['mrc-high-light-text']);
      }, [element]);
      if (highlightElements.length > 0) {
        var _element$attribs17;
        var _newElement4 = new Element(element.name, _objectSpread(_objectSpread({}, element.attribs), {}, {
          class: "".concat(((_element$attribs17 = element.attribs) === null || _element$attribs17 === void 0 ? void 0 : _element$attribs17.class) || '', " mrc-high-light-text")
        }), element.childNodes);
        replaceElement(element, _newElement4);
      }
    });
  };
  var onDocument = function onDocument() {
    if (Object.keys(imgSize).length === 0 && !timer.current) {
      timer.current = setInterval(function () {
        if (Object.keys(imgSizeRef.current).length === Object.keys(hasParsedImages.current).length && richTextWidthRef.current !== undefined) {
          setImgSize(imgSizeRef.current);
          hasParsedImages.current = {};
          clearInterval(timer.current);
        }
      }, 500);
    }
    if (Object.keys(imgLayoutSizeRef.current).length === 0) {
      setImgLayoutSize(imgLayoutSizeRef.current);
    }
  };
  var domVisitors = {
    onElement: onElement,
    onDocument: onDocument
  };
  var systemFonts = [].concat(_toConsumableArray(defaultSystemFonts), ['Georgia', 'Times New Roman', 'serif', 'Monaco', 'Courier New', 'monospace']);
  var classesStyles = _objectSpread({
    'redirection-button-to-taskbots-or-app-page': {
      width: '100%'
    },
    disabled: {
      color: 'rgba(0, 0, 0, 0.87)'
    },
    'diabled-change-order': {
      color: 'rgba(0, 0, 0, 0.54)',
      fontSize: 12
    },
    'chatbot-text-change-order-link': {
      color: '#4080ee'
    },
    'li-ql-ui-before': {
      marginTop: -19,
      marginBottom: 4
    },
    'ql-ui-before': {
      top: 20,
      left: -30,
      textAlign: 'right',
      width: 25
    },
    'ql-size-small': {
      fontSize: 16,
      lineHeight: 20
    },
    'ql-size-large': {
      fontSize: 16,
      lineHeight: 10
    },
    'ql-size-huge': {
      fontSize: 16,
      lineHeight: 10
    },
    // 'ql-font-serif': { fontFamily: 'Roboto' },
    // 'ql-font-monospace': { fontFamily: 'Roboto' },
    'ql-indent-1': {
      paddingLeft: 20
    },
    'ql-indent-2': {
      paddingLeft: 20 * 2
    },
    'ql-indent-3': {
      paddingLeft: 20 * 3
    },
    'ql-indent-4': {
      paddingLeft: 20 * 4
    },
    'li-ql-indent-1': {
      paddingLeft: 20
    },
    'li-ql-indent-2': {
      paddingLeft: 20 * 2
    },
    'li-ql-indent-3': {
      paddingLeft: 20 * 3
    },
    'li-ql-indent-4': {
      paddingLeft: 20 * 4
    },
    'ql-code-block-container': {
      backgroundColor: '#23241f',
      borderRadius: 3,
      marginVertical: 5,
      paddingVertical: 5,
      paddingHorizontal: 10,
      color: '#f8f8f2',
      overflow: 'visible',
      position: 'relative'
    },
    'ql-code-block-container-ql-ui': {
      right: 5,
      top: 5
    },
    'date-text': {
      color: 'blue',
      fontSize: 16
    },
    hidden: {
      width: 0,
      height: 0,
      fontSize: 0
    },
    'qlbt-selection-line-left-before': {
      position: 'absolute',
      left: -2,
      top: 4,
      width: 5,
      height: 5,
      backgroundColor: '#0589f3',
      borderRadius: 5
    },
    'qlbt-selection-line-right-before': {
      position: 'absolute',
      right: 5,
      bottom: 0,
      width: 5,
      height: 5,
      backgroundColor: '#0589f3',
      borderRadius: 5,
      alignSelf: 'flex-end'
    },
    'quill-better-table-wrapper': {
      width: '100%',
      overflow: 'hidden'
    },
    'quill-better-table': {
      width: '100%'
    },
    'underline-a': {
      textDecorationLine: 'none'
    },
    'table-a': {
      overflow: 'hidden',
      maxWidth: '100%'
    },
    'qlbt-operation-menu': {
      backgroundColor: '#fff',
      shadowOffset: {
        width: 0,
        height: 2
      },
      shadowRadius: 8,
      shadowColor: 'rgba(0, 0, 0)',
      shadowOpacity: 0.15,
      fontSize: 16,
      zIndex: 100,
      overflow: 'hidden'
    },
    'qlbt-operation-menu-dividing': {
      height: 1,
      backgroundColor: '#efefef'
    },
    'qlbt-operation-menu-subtitle': {
      color: '#999',
      fontSize: 16,
      paddingVertical: 5,
      paddingHorizontal: 16
    },
    'qlbt-operation-color-picker': {
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: 'wrap',
      paddingTop: 0,
      paddingHorizontal: 16,
      paddingBottom: 10,
      backgroundColor: '#fff',
      overflow: 'hidden'
    },
    'qlbt-operation-color-picker-item': {
      width: 20,
      height: 20,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: '#595959',
      marginRight: 5,
      marginBottom: 5
    },
    'qlbt-operation-menu-item': {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 10,
      paddingHorizontal: 16,
      backgroundColor: '#fff',
      color: '#595959',
      overflow: 'hidden'
    },
    'qlbt-operation-menu-icon': {
      marginRight: 8,
      height: 20,
      width: 20,
      fontSize: 0
    },
    'qlbt-col-tool': {
      position: 'absolute',
      flexDirection: 'row',
      alignItems: 'flex-end',
      overflow: 'hidden',
      zIndex: 99,
      height: 16
    },
    'qlbt-col-tool-cell': {
      position: 'relative',
      backgroundColor: '#fff',
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: '#000',
      borderLeftWidth: 0
    },
    'qlbt-col-tool-cell-first-child': {
      borderLeftWidth: 1,
      borderStyle: 'solid',
      borderLeftColor: '#000'
    },
    'qlbt-col-tool-cell-holder': {
      position: 'absolute',
      right: -1,
      top: 0,
      bottom: 0,
      zIndex: 3,
      width: 1,
      backgroundColor: 'transparent'
    },
    'qlbt-col-tool-cell-holder-faker': {
      position: 'absolute',
      top: 0,
      left: -6,
      width: 8,
      height: '100%'
    },
    // 使用alignSelf, 容器缩小到其内容的大小
    'expend-icon-container': {
      position: 'relative',
      alignSelf: 'flex-start',
      lineHeight: 0
    },
    'expend-icon': {
      position: 'absolute',
      right: 4,
      top: 4,
      width: 20,
      height: 20
    },
    'mrc-high-light-text': {
      color: '#ee4d2d'
    },
    'tip-message-content': {
      fontSize: 12,
      lineHeight: 14
    },
    'ql-align-center': {
      textAlign: 'center'
    },
    'ql-align-right': {
      textAlign: 'right'
    },
    'ui-optimisation-recommender': {
      fontSize: (baseStyles === null || baseStyles === void 0 ? void 0 : baseStyles.fontSize) || 14
    }
  }, classNameStyles || {});
  var changeOrderTagStyles = {
    p: {
      marginVertical: 0,
      fontSize: 12,
      textAlign: 'center'
    },
    a: {
      color: '#4080ee',
      textDecorationLine: 'none',
      fontSize: 12,
      lineHeight: 14
    }
  };
  var tagsStyles = _objectSpread({
    div: {
      maxWidth: '100%',
      lineHeight: 20,
      fontSize: 16
    },
    span: {
      maxWidth: '100%',
      fontSize: 16
    },
    // fontFamily: 'Roboto',
    p: {
      maxWidth: '100%',
      marginVertical: 0,
      fontSize: 16,
      textDecorationLine: 'none'
    },
    sub: {
      marginVertical: 0,
      fontSize: 16,
      textDecorationLine: 'none'
    },
    sup: {
      marginVertical: 0,
      fontSize: 16,
      textDecorationLine: 'none'
    },
    s: {
      marginVertical: 0,
      fontSize: 16,
      textDecorationLine: 'none'
    },
    h1: _objectSpread(_objectSpread({}, FONT_WEIGHT_MEDIUM), {}, {
      fontSize: 16,
      textDecorationLine: 'underline'
    }),
    h2: _objectSpread(_objectSpread({}, FONT_WEIGHT_MEDIUM), {}, {
      fontSize: 16,
      textDecorationLine: 'underline'
    }),
    label: {
      maxWidth: '100%',
      fontSize: 16
    },
    img: {
      maxWidth: '100%',
      marginVertical: 8
    },
    iframe: {
      maxWidth: '100%',
      borderWidth: 0,
      marginVertical: 30
    },
    b: _objectSpread(_objectSpread({}, FONT_WEIGHT_MEDIUM), {}, {
      fontSize: 16
    }),
    strong: _objectSpread(_objectSpread({}, FONT_WEIGHT_MEDIUM), {}, {
      fontSize: 16
    }),
    table: {
      width: '100%',
      fontSize: 16,
      margin: 40
    },
    a: {
      color: '#4080ee',
      textDecorationLine: 'none',
      fontSize: 16
    },
    td: {
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'rgb(0, 0, 0)',
      paddingVertical: 2,
      paddingHorizontal: 5
    },
    ol: {
      listStyleType: 'none',
      fontSize: 16,
      marginTop: 0,
      marginBottom: 0
    },
    ul: {
      listStyleType: 'none',
      fontSize: 16,
      marginTop: 0,
      marginBottom: 0
    },
    li: {
      position: 'relative',
      fontSize: 16
    },
    blockquote: {
      borderLeftWidth: 4,
      borderStyle: 'solid',
      borderLeftColor: '#ccc',
      marginVertical: 5,
      paddingLeft: 16,
      marginHorizontal: 0
    }
  }, tagStyles || {});
  var source = {
    html: "<div class='rich-text ".concat(className || '', "'>\n    <div class='rich-text-content ").concat(isUIOptimisationRecommender ? 'ui-optimisation-recommender' : '', "' />\n      ").concat(html, "\n    </div>")
  };
  useEffect(function () {
    handleAddEventListener();
    /**
     * TODO: Track
     */
    // props.changeTrackCloseArticleContentData?.({ startTime: new Date() });

    return function () {
      clearInterval(timer.current);
      handleRemoveEventListener();
    };
  }, []);
  return /*#__PURE__*/React.createElement(View, {
    onLayout: function onLayout(e) {
      var width = e.nativeEvent.layout.width;
      richTextWidthRef.current = width;
    }
  }, /*#__PURE__*/React.createElement(RenderHtml, {
    contentWidth: contentWidth || screenWidth,
    source: source,
    systemFonts: systemFonts,
    classesStyles: classesStyles,
    tagsStyles: msgType === MsgType.default ? tagsStyles : changeOrderTagStyles,
    domVisitors: domVisitors,
    WebView: WebView,
    renderers: renderers,
    renderersProps: renderersProps,
    customHTMLElementModels: customHTMLElementModels,
    baseStyle: _objectSpread({
      margin: 0,
      color: '#000000'
    }, baseStyles),
    enableExperimentalBRCollapsing: true,
    defaultTextProps: {
      allowFontScaling: false
    }
  }));
};